module.exports = __webpack_public_path__ + "img/14t.prt.4968a419.jpg";